var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBgFooter1Logo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 537,
    height: 493,
    viewBox: "0 0 537 493",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.4376 402.575C90.7397 468.865 111.539 546.049 111.334 624.846C111.373 648.579 109.551 672.272 105.889 695.67L107.305 697.323C145.491 738.596 194.902 765.476 248.252 774.001C301.602 782.525 356.067 772.241 403.616 744.667C451.164 717.093 489.28 673.687 512.342 620.85C535.403 568.014 542.19 508.544 531.702 451.209L531.702 450.795C500.362 280.267 423.023 123.662 309.484 0.824662L0.688939 334.348C19.7622 355.102 36.7715 377.97 51.4376 402.575V402.575Z",
    fill: "url(#paint0_linear_1782_60)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1782_60",
    x1: 312.044,
    y1: 760.829,
    x2: 209.876,
    y2: 58.4172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E0C77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2563EB"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgFooter1Logo);
export default __webpack_public_path__ + "static/media/bg-footer-1-logo.7c53c2c889fadcabfdf80b39edcacdd6.svg";
export { ForwardRef as ReactComponent };